import React from 'react';

import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function TribesTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  onRowClick,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      tableLayout="fixed"
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { TribesTable };
